import 'alpinejs';

import CopyInput from './components/CopyInput';
import DateTimePicker from './components/DateTimePicker';
import DropDownSimple from './components/DropDownSimple';
import Modal from './components/Modal';
import PostBidForm from './components/PostBidForm';
import PostBidsList from './components/PostBidsList';
import PostConditionTypeSelector from './components/PostConditionTypeSelector';
import PostConditionTypeSelectorMultiple from './components/PostConditionTypeSelectorMultiple';
import PostImageUpload from './components/PostImageUpload';
import PostMediaPreview from './components/PostMediaPreview';
import PostPriceCurrent from './components/PostPriceCurrent';
import PostTimeLeft from './components/PostTimeLeft';
import PostQuestionBox from './components/PostQuestionBox';
import PrivateMessageForm from './components/PrivateMessageForm';
import PrivateMessageList from './components/PrivateMessageList';
import SocialShare from './components/SocialShare.js';

window.Huutopiste.Components = {
    CopyInput,
    DateTimePicker,
    DropDownSimple,
    Modal,
    PostBidForm,
    PostBidsList,
    PostConditionTypeSelector,
    PostConditionTypeSelectorMultiple,
    PostImageUpload,
    PostMediaPreview,
    PostPriceCurrent,
    PostQuestionBox,
    PostTimeLeft,
    PrivateMessageForm,
    PrivateMessageList,
    SocialShare,
};
